import { useQuery } from '@tanstack/react-query';
import { useAccessToken } from '@/auth/useAccessToken';
import { applicationsApi, type ApplicationOption } from './applicationsApi';

/**
 * Active application options for the submit-ticket picker. Cached for a few
 * minutes — the list changes rarely and admin edits invalidate it explicitly.
 */
export function useActiveApplications() {
  const getAccessToken = useAccessToken();
  return useQuery<ApplicationOption[]>({
    queryKey: ['applications', 'active'],
    queryFn: ({ signal }) => applicationsApi.listActive(getAccessToken, signal),
    staleTime: 5 * 60_000
  });
}

/** Full list (incl. inactive) for the admin management screen. */
export function useAllApplications() {
  const getAccessToken = useAccessToken();
  return useQuery<ApplicationOption[]>({
    queryKey: ['applications', 'all'],
    queryFn: ({ signal }) => applicationsApi.listAll(getAccessToken, signal)
  });
}
